import { render, staticRenderFns } from "./gc-popup-label-printing.vue?vue&type=template&id=1b3c7561"
import script from "./gc-popup-label-printing.vue?vue&type=script&lang=js"
export * from "./gc-popup-label-printing.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-label-printing.vue?vue&type=style&index=0&id=1b3c7561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports